import { useEffect, useState } from 'react';
import { IAuftrag, IAuftragHinweisResponse } from '../types/Types';
import MaxInputAnzahlComponent from './MaxInputAnzahlComponent';
import { useCreateHinweisMutation, useGetHinweiseMutation } from '../api/AuftragAPI';
import { formatToEuroDateTime } from '../util/DateUtils';

interface ThisProps {
  auftragUid: string,
}

const HinweisComponent: React.FC<ThisProps> = (props) => {

  const [getHinweise] = useGetHinweiseMutation();
  const [createHinweis] = useCreateHinweisMutation();

  const [hinweise, setHinweise] = useState<IAuftragHinweisResponse[]>([]);

  const [hinweisFuerAG, setHinweisFuerAG] = useState<string>("");
  const [hinweisEigene, setHinweisEigene] = useState<string>("");

  const speicherHinweiseEigene = async () => {
    if (hinweisEigene !== "") {
      createHinweis({ uid: props.auftragUid, typ: "EIGENE", text: hinweisEigene })
        .then(() => getHinweisListe())
        .then(() => setHinweisEigene(""))
    }
  }

  const speicherHinweiseFuerAG = async () => {
    if (hinweisFuerAG !== "") {
      createHinweis({ uid: props.auftragUid, typ: "AG", text: hinweisFuerAG })
        .then(() => getHinweisListe())
        .then(() => setHinweisFuerAG(""))
    }
  }

  const getHinweisListe = async () => {
    getHinweise(props.auftragUid).unwrap().then((data) => {
      setHinweise(data);
    });
  }

  useEffect(() => {
  }, []);

  return (
    <>
      <form onSubmit={(e) => { e.preventDefault(); speicherHinweiseFuerAG(); }}>
        <div>
          <label>Hinweis für Auftraggeber</label>
          <textarea style={{ width: "100%" }} rows={5} value={hinweisFuerAG} maxLength={255} onChange={(e) => setHinweisFuerAG(e.target.value)} ></textarea>
          <MaxInputAnzahlComponent aktuell={hinweisFuerAG.length} max={255} />
        </div>
        <button type="submit" className="btn btn-primary">Speichern</button>
      </form>

      <form onSubmit={(e) => { e.preventDefault(); speicherHinweiseEigene(); }}>
        <div>
          <label>Hinweis für uns</label>
          <textarea style={{ width: "100%" }} rows={5} value={hinweisEigene} maxLength={255} onChange={(e) => setHinweisEigene(e.target.value)} />
          <MaxInputAnzahlComponent aktuell={hinweisEigene.length} max={255} />
        </div>
        <button type="submit" className="btn btn-primary">Speichern</button>
      </form>

      {hinweise?.map((e, index) => <>
        <div key={e.uid}>{formatToEuroDateTime(e.erstelltAm)} {e.erstelltVon} {e.typ} {e.text}</div>
      </>)}
    </>
  );
}

export default HinweisComponent;
